import React from 'react';

export interface TrophyIconProps {
  /** Rendered width and height in px. */
  size?: number;
  className?: string;
}

/** Outline trophy (stroke = `currentColor`); decorative, hidden from assistive tech. */
export const TrophyIcon: React.FC<TrophyIconProps> = ({ size = 20, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6 9H4.5a2.5 2.5 0 010-5C7 4 7 7 7 7" />
    <path d="M18 9h1.5a2.5 2.5 0 000-5C17 4 17 7 17 7" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0012 0V2z" />
  </svg>
);

export default TrophyIcon;
